import { useQuery } from '@tanstack/react-query'
import { getWaitVolumePrediction } from './apis'
import { GetWaitVolumePredictionReq } from './types'

export const outboundWaitVolumeQueryKeys = {
  all: ['OUTBOUND_WAIT_VOLUME'] as const,
  prediction: (params: GetWaitVolumePredictionReq) => [...outboundWaitVolumeQueryKeys.all, 'PREDICTION', params] as const,
}

/** 슬롯별 예측 물량 조회 — 자동 폴링 없음. 갱신은 refetch로. */
export const useWaitVolumePrediction = (params: GetWaitVolumePredictionReq) => {
  const { data, ...rest } = useQuery({
    queryKey: outboundWaitVolumeQueryKeys.prediction(params),
    queryFn: () => getWaitVolumePrediction(params),
    select: (res) => res.data,
    refetchOnWindowFocus: false,
  })

  return { data, ...rest }
}
